<template>
    
    <b-container class="p-0">
        <b-row class="my-2 mx-0">
            <b-col>
                <h5 class="font-weight-bold">Add Client</h5>
                <hr />
            </b-col>
        </b-row>
        <client-form />
    </b-container>
</template>
<script>

import {ModalMixin} from '@/mixins';
import ClientForm from '@/components/forms/ClientForm';
export default {
    name: "ClientModal",
    mixins: [ModalMixin],
    components:{
        ClientForm
    },
    data(){
        return {}
    }
    
}
</script>

<style>
    .equipment-list .dropdown-menu{
        overflow: scroll;
        max-height: 50vh;
    }
    
    .equipment-list .dropdown-menu li+li{
        border-top: 1px solid #ccc;
    } 
    fieldset.form-group legend {
        text-transform: capitalize;
    }
</style>